'use client'

import { useTranslations } from 'next-intl'
import { FaceImage } from '@components/images/FaceImage/FaceImage'
import './starsBadge.css'

interface StarsBadgeProps {
  score: number
  onClick?: () => void
}

export function StarsBadge({ score, onClick }: StarsBadgeProps) {
  const t = useTranslations('productsPage')
  const percent = score * 25
  const alt = t('compatibilityPercent', { percent })

  if (!onClick) {
    return <FaceImage id="stars-badge" score={score} size={32} alt={alt} />
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={t('compatibilityExplainAriaLabel', { percent })}
      className="stars-badge-button"
    >
      <FaceImage id="stars-badge" score={score} size={32} alt={alt} />
    </button>
  )
}
